// extracted by mini-css-extract-plugin
export default {"footbar":"Footer_footbar__WM05a","glyphs":"Footer_glyphs__XFisC","madeIn":"Footer_madeIn__nhF-r","heart":"Footer_heart__xRdjE"};